import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import ProductAPI from '../../../api/ProductAPI';
import Util from '../../../util/Util';
import Const from '../../../util/Constants';
import Display from '../../../util/Display';
import ApiUiController from '../../../controller/ApiUiController';

class ProductUnitMeasureList extends React.Component {

  constructor(props) {
    super(props);
    this.measures = [];
    this.state = { ...this.state, measure: {}, popup: false, inApiCall: true };

    const model = reactLocalStorage.getObject(Const.Model).unit_measure;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() { if (this.List) { ProductAPI.listUnitMeasure(this.onReceived, this.onFail); } }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = measures => {
    this.measures = measures;
    this.setState({ inApiCall: false });
  };

  show = i => {
    this.setState({
      ...this.state,
      measure: {
        id: i === -1 ? 0 : this.measures[i].id,
        name: i === -1 ? '' : this.measures[i].name
      }, popup: true
    });
  };
  hide = () => { this.setState({ ...this.state, popup: false }); };
  save = () => {
    if (this.state.measure.name.trim().length === 0) {
      return;
    }
    this.setState({ ...this.state, popup: false, inApiCall: true });
    ProductAPI.saveUnitMeasure(this.state.measure, this.success, this.onFail);
  };
  success = () => {
    Util.showNotification('Successful', 'Unit of Measure successfully saved', 'success');
    this.props.onModuleChanged();
    ProductAPI.listUnitMeasure(this.onReceived, this.onFail);
  };
  nameChange = value => this.setState({
    ...this.state,
    measure: { ...this.state.measure, name: value }
  });

  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to delete to`
      + ` ${this.measures[index].name}`, 'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        ProductAPI.deleteUnitMeasure(this.measures[index].id, this.onDelete, this.onFail);
      });
  };

  onDelete = () => {
    Util.showNotification('Successful', 'Unit of Product Deleted successfully', 'success');
    ProductAPI.listUnitMeasure(this.onReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;
    const measuresUI = this.measures.map((measure, _i) => (
      <tr key={`product_measure_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{measure.name}</td>
        <td>{Display.ModelLabelValue('user', measure.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(measure.created_date)}</td>
        <td>{Display.ModelLabelValue('user', measure.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(measure.updated_date)}</td>
        <td>
          {this.Update &&
            <div className="buttons success" onClick={() => this.show(_i)}>
              <FaPencilAlt /> Update</div>
          }
          {measure.status !== Const.AlwaysActive && this.Delete &&
            <div onClick={() => this.confirmDelete(_i)} className="buttons delete">
              <FaTrash /> Delete</div>
          }
        </td>
      </tr>
    ));

    return (
      <>
        <Modal
          show={this.state.popup} onHide={this.hide}
          size="md" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Measurement</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Unit Measurement"
                    className="mr-sm-2"
                    value={this.state.measure.name}
                    onChange={event => this.nameChange(event.target.value)} />
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer> <Button onClick={this.save}>Save</Button></Modal.Footer>
        </Modal>

        <div className="sectionlist pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 pb-3"><h3>Unit of Measurement</h3></div>
              {this.Add &&
                <div className="col-md-2 text-right pb-3">
                  <div className="buttons success"
                    onClick={() => this.show(-1)}>+ Add Measurement</div>
                </div>
              }
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Name</th>
                      <th>Created By</th>
                      <th>Created Date</th>
                      <th>Updated By</th>
                      <th>Updated Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.props.inApiCall}>
                      {measuresUI}
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default ProductUnitMeasureList;